import React, {useState, useEffect} from 'react';
import {useRouter} from 'next/router';
import classNames from 'classnames';

import {useApp} from '@context/AppProvider';

import {useCategory} from './Context/Category';
import {useMasterAttribute} from './Context/MasterAttribute';
import {useBrand} from './Context/Brand';
import {useRetailer} from './Context/Retailer';
import {useShipping} from './Context/Shipping';
import MobileFilter from './MobileFilter';
import AppliedFilter from './AppliedFilter';

function UpBlock(props) {
	const {styles, pageUrl, pageUrlFn} = props;
	const router = useRouter();
	const categories = useCategory();
	const options = useMasterAttribute();
	const brands = useBrand();
	const retailers = useRetailer();
	const shippings = useShipping();
	const [filter, setFilter] = useState([]);
	const {
		idb: {currency},
		convertCurrency,
	} = useApp();

	useEffect(() => {
		const appliedFilters = [
			...categories.filters.filter(i => i.parentId !== null),
			...retailers.filters,
			...shippings.filters,
			...brands.filters,
			...options.filters,
		];
		if (props.filters.price_from && props.filters.price_to) {
			appliedFilters.push({
				_id: 'price',
				type: 'price',
				label: `${convertCurrency(0, false, true, false)}${
					props.filters.price_from
				} - ${convertCurrency(0, false, true, false)}${props.filters.price_to}`,
			});
		}
		setFilter(appliedFilters);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		categories.filters,
		retailers.filters,
		brands.filters,
		shippings.filters,
		options.filters,
		props.filters,
		currency,
	]);

	const removeFilter = filter => {
		switch (filter.type) {
			case 'slug':
				categories.updateFilter([filter], true, false);
				break;
			case 'category': {
				let filters = categories.filters.filter(i => i._id !== filter._id);
				categories.updateFilter(filters, true);
				break;
			}
			case 'brand': {
				let filters = brands.filters.filter(i => i._id !== filter._id);
				brands.updateFilter(filters, true);
				break;
			}
			case 'retailer': {
				let filters = retailers.filters.filter(i => i._id !== filter._id);
				retailers.updateFilter(filters, true);
				break;
			}
			case 'options': {
				let filters = options.filters.filter(i => i._id !== filter._id);
				options.updateFilter(filters, true);
				break;
			}
			case 'shipping': {
				let filters = shippings.filters.filter(i => i._id !== filter._id);
				shippings.updateFilter(filters, true);
				break;
			}
			case 'price': {
				const query = {...props.filters};
				delete query.price_from;
				delete query.price_to;
				delete query.page;
				router.push({pathname: props.pageUrl, query});
				break;
			}
			default:
				break;
		}
	};

	const clearAllFilter = () => {
		retailers.updateFilter([]);
		brands.updateFilter([]);
		options.updateFilter([]);
		shippings.updateFilter([], false);
		const slug =
			categories.breadcrumbs && categories.breadcrumbs.length
				? categories.breadcrumbs[0].slug
				: 'NA';
		if (slug) {
			router.push({pathname: pageUrlFn(props, slug)});
		}
	};
	return (
		<>
			<div className='row'>
				<div className={classNames('col-md-6', styles.deskUpBlock)}>
					<AppliedFilter
						filters={filter}
						styles={styles}
						removeFilter={removeFilter}
						clearAllFilter={clearAllFilter}
					/>
				</div>
				{!props.isAuction && (
					<div className={classNames('col-md-6', styles.deskUpBlock)}>
						<SortBy styles={styles} filters={props.filters} pageUrl={pageUrl} />
					</div>
				)}
			</div>
			<MobileFilter
				{...props}
				url={pageUrl}
				filters={filter}
				styles={styles}
				categories={categories}
				options={options}
				brands={brands}
				retailers={retailers}
				params={props.filters}
				removeFilter={removeFilter}
				clearAllFilter={clearAllFilter}
			/>
		</>
	);
}

const wrapperRef = React.createRef();

const sortItems = {
	1: 'Newest First',
	2: 'Price low to high',
	3: 'Price high to low',
	4: 'Alphabetical A-Z',
	5: 'Alphabetical Z-A',
};

function SortBy(props) {
	const router = useRouter();
	const [show, setShow] = useState(false);
	const {styles, filters} = props;

	useEffect(() => {
		const outSideModalClickEvent = () => {
			if (wrapperRef && !wrapperRef.current?.contains(event.target)) {
				setShow(false);
				//removeListener();
			}
		};
		const removeListener = () => {
			document.removeEventListener('mousedown', outSideModalClickEvent);
		};
		document.addEventListener('mousedown', outSideModalClickEvent);

		return () => removeListener;
	}, []);

	const sortby = sort => {
		setShow(false);
		const query = {...props.filters, sortBy: sort};
		//if (filters.sortBy && sort === filters.sortBy) return;
		if (sort === 1) delete query.sortBy;
		delete query.page;
		router.push({pathname: props.pageUrl, query});
	};
	return (
		<div
			className={`${styles.upBlock} d-md-flex justify-content-end align-items-center`}
		>
			<div
				ref={wrapperRef}
				className={`${styles.sortBtnGroup} btn-group ${show ? 'show' : ''}`}
			>
				<button
					className={`${styles.btn}  dropdown-toggle`}
					name='recordinput'
					data-toggle='dropdown'
					onClick={() => setShow(!show)}
				>
					{filters.sortBy && filters.sortBy !== 1
						? sortItems[filters.sortBy]
						: 'Sort By'}
				</button>
				<ul
					className={`dropdown-menu ${styles.sortDropdown} ${
						show ? 'show' : ''
					}`}
					aria-labelledby='dropdownMenuButton1'
				>
					{Object.keys(sortItems).map(k => (
						<li key={k}>
							<span onClick={() => sortby(k)}>{sortItems[k]}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}

export default UpBlock;
